import { sineOut } from "svelte/easing";

export const subtlepop = (
  node: Element,
  { delay = 0, duration = 200, easing = sineOut } = {},
) => {
  return {
    delay: delay,
    duration: duration,
    easing: easing,
    css: (t: number, u: number) => {
      return `transform: scale(${0.98 + (t * 0.02)}); opacity: ${t}`;
    },
  };
};
